export default "__VITE_ASSET__DsZtaYVi__"